import React from 'react';
import { Users, Lock, Plus, Map, FolderOpen, Plug, Database } from 'lucide-react';
import { GROUPS } from '../../data/workspaceTracks';

// ── Groups ───────────────────────────────────────────────────────────────────
// Groups are the access boundary: every track, file, connection and table belongs
// to one, and only its members can see what's inside.
// ─────────────────────────────────────────────────────────────────────────────

export function GroupsView() {
  return <div className="p-6 md:p-8" data-id="element-2758" data-mp="1bkath8w578ap">
      <div className="flex flex-wrap items-center gap-3" data-id="element-2759" data-mp="1blc6hiwpy4v2">
        <h1 className="mr-auto text-[26px] font-bold text-neutral-900" data-id="element-2760" data-mp="16l7o1nc93027">
          Groups
        </h1>
        <button type="button" className="flex items-center gap-1.5 rounded-lg bg-neutral-900 px-3 py-2 text-[13px] font-medium text-white transition-colors hover:bg-neutral-800" data-id="element-2761" data-mp="11m3h73cstef1">
          <Plus size={15} data-id="element-2762" data-mp="3r9c8caqn32x1" />
          New group
        </button>
      </div>

      <p className="mt-2 max-w-2xl text-[13.5px] leading-relaxed text-neutral-500" data-id="element-2763" data-mp="3mar5s4nx075f">
        A group decides who can see what. Tracks, files, connections and tables
        all belong to a group, so access follows the group rather than being set
        item by item.
      </p>

      <ul className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3" data-id="element-2764" data-mp="mj3m0xyj0rpc">
        {GROUPS.map(g => <li key={g.name} className="rounded-xl border border-neutral-200 bg-white p-4 transition-colors hover:border-neutral-300" data-id="element-2765" data-mp="ri6smmu5n5zf">
            <div className="flex items-start gap-3" data-id="element-2766" data-mp="ct2at6r9v3ru">
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${g.shared ? 'bg-indigo-50 text-indigo-600' : 'bg-neutral-100 text-neutral-500'}`} data-id="element-2767" data-mp="hlbva79mbbmq">
                {g.shared ? <Users size={16} data-id="element-2768" data-mp="8s8lc8y6lgwu" /> : <Lock size={16} data-id="element-2769" data-mp="8tth21w8f5wa" />}
              </span>
              <div className="min-w-0 flex-1" data-id="element-2770" data-mp="8qe2r1adu0vx">
                <p className="truncate text-[14.5px] font-semibold text-neutral-900" data-id="element-2771" data-mp="3q1wzlarb1gji">
                  {g.name}
                </p>
                <p className="text-[12.5px] text-neutral-500" data-id="element-2772" data-mp="3v22s0t5ef72n">
                  {g.shared ? 'Shared' : 'Private'} ·{' '}
                  {g.members === 1 ? '1 member' : `${g.members} members`}
                </p>
              </div>
            </div>

            <dl className="mt-3.5 grid grid-cols-4 gap-2 border-t border-neutral-100 pt-3" data-id="element-2773" data-mp="324qxcbudwsi2">
              <Stat icon={Map} label="Tracks" value={g.tracks} data-id="element-2774" data-mp="2x78jc71ifn37" />
              <Stat icon={FolderOpen} label="Files" value={g.files} data-id="element-2775" data-mp="2x4mdcbu9pfn3" />
              <Stat icon={Plug} label="Links" value={g.connections} data-id="element-2776" data-mp="3utpgnca8u0oy" />
              <Stat icon={Database} label="Tables" value={g.tables} data-id="element-2777" data-mp="3puuv42kw5y15" />
            </dl>
          </li>)}
      </ul>
    </div>;
}
function Stat({
  icon: Icon,
  label,
  value
}: {
  icon: React.ElementType;
  label: string;
  value: number;
}) {
  return <div data-id="element-2778" data-mp="3fz1b5y4uf29c">
      <dt className="flex items-center gap-1 text-[11px] text-neutral-400" data-id="element-2779" data-mp="3fzb1xnxppdg3">
        <Icon size={11} data-id="element-2780" data-mp="29i65zbdwsgei" />
        {label}
      </dt>
      <dd className="mt-0.5 text-[14px] font-bold text-neutral-900" data-id="element-2781" data-mp="24ha1avlqgq81">{value}</dd>
    </div>;
}